import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: FloralWhite;

    #multi-chats {
        height: 30px;
        position: fixed;
        bottom: 0;
        display: flex;
    }
`;
